'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textFunctions = undefined;

var _textFunctions = require('./textFunctions');

var textFunctions = exports.textFunctions = [_textFunctions.color, _textFunctions.direction, _textFunctions.lineHeight, _textFunctions.letterSpacing, _textFunctions.textAlign, _textFunctions.textDecoration, _textFunctions.textIndent, _textFunctions.textShadow, _textFunctions.textTransform, _textFunctions.textOverflow, _textFunctions.unicodeBidi, _textFunctions.whiteSpace, _textFunctions.wordSpacing];